export function executeWithProbability(probability: number, callback: () => void) {
    const randomNumber = Math.random();
    if (randomNumber < probability) {
        callback();
    }
}
